import { render } from "./BAppointments.vue?vue&type=template&id=14bbe3ea&scoped=true"
import script from "./BAppointments.vue?vue&type=script&lang=js"
export * from "./BAppointments.vue?vue&type=script&lang=js"

import "./BAppointments.vue?vue&type=style&index=0&id=14bbe3ea&lang=scss&scoped=true"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bbe3ea"]])

export default __exports__